export const GUEST = 'GUEST';
export const PROPERTY = 'PROPERTY';

export const GUEST_VIEW = 'GUEST_VIEW';
export const PROPERTY_VIEW = 'PROPERTY_VIEW';

export const GUEST_EDIT = 'GUEST_EDIT';
export const PROPERTY_EDIT = 'PROPERTY_EDIT';

export const ASSET_TYPE_PROPERTY_EMAIL_SERVICES = 'property_email_services';

export const EMAIL_HEADER = 'EMAIL_HEADER';
export const EMAIL_BODY = 'EMAIL_BODY';
export const EMAIL_FOOTER = 'EMAIL_FOOTER';
export const EMAIL_BODY_TEXT = 'EMAIL_BODY_TEXT';
export const EMAIL_BODY_IMAGE = 'EMAIL_BODY_IMAGE';
export const EMAIL_BODY_BUTTON = 'EMAIL_BODY_BUTTON';
export const EMAIL_BODY_DIVIDER = 'EMAIL_BODY_DIVIDER';
export const EMAIL_TEXT_COMPONENT = 'TEXT';
export const EMAIL_IMAGE_COMPONENT = 'IMAGE';
export const EMAIL_BUTTON_COMPONENT = 'BUTTON';
export const EMAIL_DIVIDER_COMPONENT = 'DIVIDER';
export const EMAIL_SOCIAL_TEXT_COMPONENT = 'SOCIAL';

// icon smi
export const LINKEDIN = './assets/icons/email-services/linkedin.svg';
export const FACEBOOK = './assets/icons/email-services/facebook.svg';
export const TWITTER = './assets/icons/email-services/twitter.svg';
export const INSTAGRAM = './assets/icons/email-services/instagram.svg';
export const YOUTUBE = './assets/icons/email-services/youtube.svg';
export const TEXT_ICON = './assets/img/email-services/text-icon.png';
export const IMAGE_ICON = './assets/img/email-services/image-icon.png';
export const BUTTON_ICON = './assets/img/email-services/button-icon.png';
export const DIVIDER_ICON = './assets/img/email-services/divider-icon.png';

export const URL_LIST = ['App Store/Play Store link', 'Other URLs'];
export const FONT_STYLE_LIST = ['normal', 'bold', 'italic'];
export const FONT_LIST = ['Roboto'];
export const FONT_SIZE_LIST = [10, 11, 12, 13, 14, 15];
export const PARAMETERS_LIST = ['Lastname', 'Reference ID', 'Arrival Date'];
export const EMAIL_VARIABLES = [
  'gender]',
  'firstname]',
  'lastname]',
  'checkin]',
  'checkout]',
  'reservationid]',
];
export const SOCIAL_EXTRA_INPUT = [
  { id: 'linkedIn', name: 'LinkedIn' },
  { id: 'facebook', name: 'Facebook' },
  { id: 'twitter', name: 'Twitter' },
  { id: 'instagram', name: 'Instagram' },
  { id: 'youTube', name: 'YouTube' },
];

export const COMPONENT_LIST = [
  {
    id: EMAIL_TEXT_COMPONENT,
    title: 'Text',
    image: TEXT_ICON,
    subId: EMAIL_BODY_TEXT,
  },
  {
    id: EMAIL_IMAGE_COMPONENT,
    title: 'Image',
    image: IMAGE_ICON,
    subId: EMAIL_BODY_IMAGE,
  },
  {
    id: EMAIL_BUTTON_COMPONENT,
    title: 'Button',
    image: BUTTON_ICON,
    subId: EMAIL_BODY_BUTTON,
  },
  {
    id: EMAIL_DIVIDER_COMPONENT,
    title: 'Divider',
    image: DIVIDER_ICON,
    subId: EMAIL_BODY_DIVIDER,
  },
];
